import './../../styles/Account.css';

import Container from '../../components/Layout/Container';

import Input from '../../components/TextField/Input';
import { Button } from '../../components/Button/Button';
import { useState } from 'react';
import { fetchPut } from '../../hooks/fetch';
import { validatePassword } from '../../hooks/useValidate';

export default function ResetPassword() {
	const pageName = '비밀번호 재설정';
	const [pwInfo, setPwInfo] = useState({ newPw: "", newPwChk: "" });
	
	const onChangePwInfo = (e) => {
		setPwInfo({
			...pwInfo,
			[e.target.name]: e.target.value
		});
	}

	function submit() {
		if(!validatePassword(pwInfo.newPw, pwInfo.newPwChk)) {
			return;	
		}

		fetchPut(
			"/users/reset/password",
			"비밀번호 재설정에 성공",
			pwInfo,
			() => { window.location.replace("/account/login") }
		);
	}

	return (
		<main id="account-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<Container>
				<div className="page-content login-page">
					<div className="gs-account-form">
						<h1 className="top">{pageName}</h1>
						<p className="gs-bullet fc-cerulean-blue">
							비밀번호는 영문+숫자+특수문자 포함 8자리 이상
						</p>
						<div>
							<Input.Group>
								<Input.PasswordEye
									id="user-password"
									label="새 비밀번호를 입력해주세요."
									placeholder="새 비밀번호 입력"
									name="newPw"
									value={pwInfo.newPw}
									onChange={onChangePwInfo}
									maxLength={20}
								/>
								<Input.PasswordEye
									id="user-re-password"
									label="새 비밀번호를 다시 입력해주세요."
									placeholder="새 비밀번호 확인 입력"
									name="newPwChk"
									value={pwInfo.newPwChk}
									onChange={onChangePwInfo}
									maxLength={20}
								/>
							</Input.Group>
							<div className="gs-bottom-btns col">
								<Button
									className="submit"
									onClick={submit}
								>
									<strong>확 인</strong>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
